/**
 * Share plain text through the OS share sheet (so the user can pick WhatsApp,
 * Instagram DM, etc.). Falls back to WhatsApp web on desktop, where there's no
 * native share. Sharing an image (for Instagram stories) is a later step.
 */
export async function shareText(text: string): Promise<void> {
  if (typeof navigator !== 'undefined' && navigator.share) {
    try {
      await navigator.share({ text });
    } catch {
      // The user dismissed the share sheet — nothing to do.
    }
    return;
  }
  window.open(`https://wa.me/?text=${encodeURIComponent(text)}`, '_blank', 'noopener,noreferrer');
}
